module.exports = __webpack_public_path__ + "static/media/starProduct7.17d40437.png";